<template>
    <v-container
        :id="
            section.columnId && section.columnId[$i18n.locale]
                ? section.columnId[$i18n.locale].current
                : section._key
        "
        class="text-center pt-8 pb-8 bg--ltblue"
        fluid
    >
        <v-row column justify-center align-center>
            <v-col
                v-if="section.heading && section.heading[$i18n.locale]"
                cols="12"
            >
                <h3 :class="{ uppercase: isUppercase }">
                    {{ section.heading[$i18n.locale] }}
                </h3>
            </v-col>
            <v-col
                v-if="section.blurbage && section.blurbage[$i18n.locale]"
                cols="12"
                class="pt-0 pb-0"
            >
                <v-container class="pa-0">
                    <v-row no-gutters>
                        <v-col cols="12" class="subtitle-2">
                            <BlockContent
                                :blocks="section2.blurbage[$i18n.locale]"
                                :serializers="serializers"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col v-if="section.ctaLinks" cols="12">
                <CtaLinks :links="section.ctaLinks" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import CtaLinks from '~/components/CtaLinks'
import serializers from '~/util/sanity/serializers'
export default {
    name: 'CtaHeadingBlurbButton',
    components: {
        CtaLinks
    },
    props: {
        section: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            serializers
        }
    },
    computed: {
        isUppercase() {
            return this.section.headingUppercase
        },
        section2(){
            var temp = this.section
            temp.blurbage.en.map(x=>{
                if(x._type==='cloudinary')
                    x.width = '620'
                    x.height= '400'
                    x.crop='fit'
            })
            return temp;
        }
    }
}
</script>
